import { VFC } from 'react'
import { LoginUser } from 'src/models/User'
import { validatePassword } from 'src/utils/validators'
import { FormInput, SimpleForm } from '../formComponents'
import { ProfileEditorWrapper } from '../ProfileLayout'
import { _message_submenu } from 'src/styles/colors'

type PasswordFormProps = {
  user: LoginUser
  submit: (oldPassword: string, newPassword: string) => Promise<any>
}
type PasswordFormData = {
  password: string
  newPassword: string
  newPasswordConfirm: string
}

export const PasswordForm: VFC<PasswordFormProps> = ({ user, submit }) => (
  <ProfileEditorWrapper user={user}>
    <SimpleForm
      title="パスワード編集"
      description="パスワードは大文字・小文字・数字をそれぞれ1文字以上含めた、8文字以上の文字列を設定してください。"
      submitLabel="変更する"
      succeededMessage="パスワードを更新しました"
      submit={async (data: PasswordFormData) => {
        if (!data.password || !data.newPassword || !data.newPasswordConfirm)
          return {
            data: undefined,
            error: { errorMessages: ['未入力の項目があります'] },
          }
        const result = validatePassword(data.newPassword)
        if (result)
          return {
            data: undefined,
            error: { errorMessages: [result.error] },
          }

        if (data.newPassword !== data.newPasswordConfirm)
          return {
            data: undefined,
            error: { errorMessages: ['新しいパスワードが一致しません'] },
          }
        return submit(data.password, data.newPassword).catch(() => ({
          data: undefined,
          error: {
            errorMessages: [
              'エラーが発生しました。現在のパスワードに誤りがないかご確認ください。',
            ],
          },
        }))
      }}
    >
      <FormInput
        id="password"
        type="password"
        autoComplete="new-password"
        label="現在のパスワード"
        placeholder="大小英数字を含む8文字以上"
      />
      <FormInput
        id="newPassword"
        type="password"
        autoComplete="new-password"
        label="新しいパスワード"
        placeholder="大小英数字を含む8文字以上"
      />
      <FormInput
        id="newPasswordConfirm"
        type="password"
        autoComplete="new-password"
        placeholder="大小英数字を含む8文字以上"
        label="新しいパスワードの確認"
      />
    </SimpleForm>
  </ProfileEditorWrapper>
)
